import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
      <path
        d="m36.51,75H3.98c-1.63,0-2.98-1.33-2.98-2.97V8.72c0-1.4.61-2.72,1.63-3.51C9.67-.35,31.43-.41,37.92,5.08c1,.84,1.56,2.12,1.56,3.47v63.48c.01,1.64-1.32,2.97-2.97,2.97h0ZM20.32,1.81c-6.98,0-14.04,1.32-17.39,3.95-.75.59-1.2,1.57-1.2,2.62v63.3c0,1,.82,1.83,1.83,1.83h32.61c1,0,1.83-.82,1.83-1.83V8.21c0-1.03-.43-1.98-1.17-2.6-2.99-2.54-9.7-3.8-16.51-3.8h0Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m8.81,51.12c-1.64,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Zm0-4.83c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m19.89,51.12c-1.64,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Zm0-4.83c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m30.98,51.12c-1.64,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Zm0-4.83c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m8.81,13.14c-1.64,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Zm0-4.83c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m30.98,13.14c-1.64,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Zm0-4.83c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m8.81,60.46c-1.64,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Zm0-4.83c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m19.89,60.46c-1.64,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Zm0-4.83c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m30.98,60.46c-1.64,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Zm0-4.83c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m8.81,69.79c-1.64,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Zm0-4.83c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m19.89,69.79c-1.64,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Zm0-4.83c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m30.98,69.79c-1.64,0-2.98-1.34-2.98-2.98s1.34-2.98,2.98-2.98,2.98,1.34,2.98,2.98-1.34,2.98-2.98,2.98Zm0-4.83c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m19.89,41.03c-7.42,0-13.46-6.04-13.46-13.46s6.04-13.45,13.46-13.45,13.46,6.04,13.46,13.46-6.04,13.45-13.46,13.45Zm0-25.77c-6.79,0-12.31,5.53-12.31,12.31s5.53,12.31,12.31,12.31,12.31-5.53,12.31-12.31-5.53-12.31-12.31-12.31Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m19.89,36.17c-4.74,0-8.6-3.86-8.6-8.6s3.86-8.6,8.6-8.6,8.6,3.86,8.6,8.6-3.86,8.6-8.6,8.6Zm0-16.07c-4.12,0-7.47,3.35-7.47,7.47s3.35,7.47,7.47,7.47,7.47-3.35,7.47-7.47-3.35-7.47-7.47-7.47Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m19.89,20.1c-.31,0-.57-.25-.39-.57v-4.83c-.17-.31.08-.57.39-.57s.57.25,1.09.57v4.83c-.52.31-.77.57-1.09.57Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m11.86,28.38h-4.83c-.31-.24-.57-.49-.57-.8s.25-.57.57-.68h4.83c.31.11.57.36.57.68s-.25.57-.57.8Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m19.89,41.01c-.31,0-.57-.25-.39-.57v-4.83c-.17-.31.08-.57.39-.57s.57.25,1.09.57v4.83c-.52.31-.77.57-1.09.57Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m32.76,28.38h-4.83c-.31-.24-.57-.49-.57-.8s.25-.57.57-.68h4.83c.31.11.57.36.57.68s-.25.57-.57.8Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m19.89,32.49c-2.71,0-4.91-2.2-4.91-4.91s2.2-4.91,4.91-4.91,4.91,2.2,4.91,4.91-2.21,4.91-4.91,4.91Zm0-8.68c-2.08,0-3.77,1.69-3.77,3.77s1.69,3.77,3.77,3.77,3.77-1.69,3.77-3.77-1.69-3.77-3.77-3.77Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
      <path
        d="m18.02,9.54v-3.74c0-.71.39-1.39,1.05-1.68,1.34-.59,2.65.4,2.65,1.68v3.76c0,1.28-1.3,2.24-2.63,1.69-.67-.28-1.07-.98-1.07-1.71Zm1.87-4.29c-.35,0-.62.28-.39.62v3.6c-.23.35.05.62.39.62s.62-.28,1.09-.62v-3.6c-.46-.35-.74-.62-1.09-.62Z"
        fill={colourFill}
        stroke={colourFill}
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default ServiceIcon;
